
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.003 12.076A1.06 1.06 0 0111 12V4a1 1 0 112 0v8l2.4-1.8a1 1 0 111.2 1.6l-4 3a1 1 0 01-1.175.018l-4-2.814a1 1 0 111.15-1.636l2.428 1.708zm8.703 7.63A.997.997 0 0119 20H5a.997.997 0 01-.706-.294A.997.997 0 014 19v-2c0-.55.45-1 1-1s1 .45 1 1v1h12v-1c0-.55.45-1 1-1s1 .45 1 1v2a.997.997 0 01-.294.706z"}})])
          )
        }
      }
    